function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var saito = require('./../../lib/saito/saito');
var ModTemplate = require('../../lib/templates/modtemplate');
var CryptoSelectAmount = require('./lib/overlays/select-amount');
var CryptoInadequate = require('./lib/overlays/inadequate');
var AcceptStake = require('./lib/overlays/accept-stake');
var AdjustStake = require('./lib/overlays/adjust-stake');
var Crypto = /*#__PURE__*/function (_ModTemplate) {
  function Crypto(app) {
    var _this;
    _classCallCheck(this, Crypto);
    _this = _callSuper(this, Crypto, [app]);
    _this.app = app;
    _this.styles = ['/crypto/style.css'];
    _this.name = 'Crypto';
    _this.slug = 'crypto';
    _this.description = 'Enable crypto gaming';
    _this.categories = 'Utility Entertainment';
    _this["class"] = 'utility';
    _this.status = 'prod';
    _this.balances = {};
    _this.overlay = new CryptoSelectAmount(app, _this);
    _this.overlay_inadequate = new CryptoInadequate(app, _this);
    _this.approve_overlay = new AcceptStake(app, _this);
    _this.adjust_overlay = new AdjustStake(app, _this);
    return _this;
  }
  _inherits(Crypto, _ModTemplate);
  return _createClass(Crypto, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app) {
        var _this2 = this;
        var mod_list, _iterator, _step, m;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _superPropGet(Crypto, "initialize", this, 3)([app]);
            case 1:
              if (app.BROWSER) {
                this.attachStyleSheets();
              }

              //
              // Turn on crypto for all games that don't explicity opt out
              //
              mod_list = app.modules.returnModulesRespondingTo('arcade-games');
              _iterator = _createForOfIteratorHelper(mod_list);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  m = _step.value;
                  if (m.can_bet !== 0) {
                    m.can_bet = 1;
                  }
                }

                //
                // set max balance
                //
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              app.connection.on('accept-game-stake', /*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(sobj) {
                  return _regenerator().w(function (_context) {
                    while (1) switch (_context.n) {
                      case 0:
                        console.log('accept-game-stake sobj: ', sobj);
                        _context.n = 1;
                        return _this2.app.wallet.setPreferredCrypto(sobj.ticker);
                      case 1:
                        if (_typeof(sobj.stake) == 'object') {
                          _this2.adjust_overlay.render(sobj);
                        } else {
                          _this2.approve_overlay.render(sobj);
                        }
                      case 2:
                        return _context.a(2);
                    }
                  }, _callee);
                }));
                return function (_x2) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function initialize(_x) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "respondTo",
    value: function respondTo() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      /*****
      if (type == 'game-menu') {
      //
      // This should be a game module
      //
      let gm = this.app.modules.returnActiveModule();
      //
      // If it isn't a game module or a bettable game
      //
      if (!gm?.game?.cryptos) {
      return null;
      }
      //
      // Returns an object of CRYPTO(string): MAX_BET(float)
      //
      let ac = this.calculateAvailableCryptos(gm.game.cryptos);
      let menu = {
      id: 'game-crypto',
      text: 'Crypto',
      submenus: []
      };
      //
      // Table games set game.crypto = "CHIPS" so this blocks them from dynamically adding a stake
      //
      if (!gm.game?.crypto) {
      for (let ticker in ac) {
      try {
      	let my_balance = parseFloat(gm.game.cryptos[gm.game.player][ticker].balance);
      	console.log(`My ${ticker} balance: `, my_balance, ac[ticker]);
      	if (my_balance > 0) {
      		menu.submenus.push({
      			parent: 'game-crypto',
      			text: ticker,
      			id: 'game-crypto-' + ticker,
      			class: 'game-crypto-ticker',
      			callback: async (app, game_mod) => {
      				this.attachStyleSheets();
      					this.max_balance = Math.max(Number(ac[ticker]), my_balance);
      				this.max_balance = this.max_balance.toFixed(8);
      				this.max_match = ac[ticker];
      					this.overlay.ticker = ticker;
      					this.overlay.render((ticker, amount, match_amount = null) => {
      					console.log('SELECTED CRYPTO: ', ticker, amount, match_amount);
      					if (match_amount) {
      						//
      						// asymmetrical staking -- format like pre-game options
      						//
      						let stake = {};
      						stake.min = match_amount;
      						stake[this.publicKey] = amount;
      						amount = stake;
      					}
      						game_mod.menu.hideSubMenus();
      					game_mod.proposeGameStake(ticker, amount);
      				});
      			}
      		});
      	}
      } catch (err) {
      console.log("Error displaying crypto values...");
      }
      }
      } else if (gm.game.crypto != 'CHIPS') {
      menu.submenus.push({
      	parent: 'game-crypto',
      	text: gm.game.crypto + ' ✓',
      	id: 'game-crypto-stake',
      	class: 'game-crypto-ticker',
      	callback: async (app, game_mod) => {
      		game_mod.showStakeOverlay();
      	}
      });
      }
      if (Object.keys(ac).length == 0) {
      menu.submenus.push({
      	parent: 'game-crypto',
      	text: 'No Cryptos Available',
      	id: 'game-crypto-none',
      	class: 'game-crypto-none',
      	callback: (app, game_mod) => {
      		game_mod.menu.hideSubMenus();
      		salert('Players do not have any common crypto to play with...');
      	}
      });
      }
      if (menu.submenus.length == 0) {
      menu.submenus.push({
      	parent: 'game-crypto',
      	text: 'No Cryptos Available',
      	id: 'game-crypto-none',
      	class: 'game-crypto-none',
      	callback: (app, game_mod) => {
      		game_mod.menu.hideSubMenus();
      		salert('You cannot add a stake to this game...');
      	}
      });
      }
      return menu;
      }
      ****/
      return _superPropGet(Crypto, "respondTo", this, 3)([type]);
    }
  }, {
    key: "renderInto",
    value: function () {
      var _renderInto = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(qs) {
        var _this3 = this;
        var _document$querySelect, _this$gm2, game_name, _this$gm, hook;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (!(qs == '#arcade-advance-opt')) {
                _context4.n = 5;
                break;
              }
              this.max_match = 0;
              game_name = (_document$querySelect = document.querySelector("input[name='game']")) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.value;
              if (!game_name) {
                _context4.n = 2;
                break;
              }
              this.gm = this.app.modules.returnModuleByName(game_name);
              if ((_this$gm = this.gm) !== null && _this$gm !== void 0 && _this$gm.can_bet) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              _context4.n = 3;
              break;
            case 2:
              return _context4.a(2);
            case 3:
              this.attachStyleSheets();
              _context4.n = 4;
              return this.app.wallet.returnAvailableCryptosAssociativeArray();
            case 4:
              this.balances = _context4.v;
              if ((_this$gm2 = this.gm) !== null && _this$gm2 !== void 0 && _this$gm2.opengame) {
                //this.max_match = -1;
              }
              this.app.browser.addElementToSelector("<div class=\"game-wizard-crypto-hook saito-button-secondary saito-anchor\"><i class=\"fa-solid fa-coins\"></i></div>", qs);
              hook = document.querySelector('.game-wizard-crypto-hook');
              if (hook) {
                hook.onclick = /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(e) {
                    var _hook$dataset, _hook$dataset2;
                    var balance;
                    return _regenerator().w(function (_context3) {
                      while (1) switch (_context3.n) {
                        case 0:
                          _context3.n = 1;
                          return _this3.app.wallet.getBalance('SAITO');
                        case 1:
                          balance = _context3.v;
                          if (!(balance === 0n)) {
                            _context3.n = 2;
                            break;
                          }
                          siteMessage('A SAITO balance is needed to add a stake...', 3000);
                          _this3.app.connection.emit('saito-purchase-launch');
                          return _context3.a(2);
                        case 2:
                          _this3.overlay = new CryptoSelectAmount(_this3.app, _this3);
                          _this3.overlay.fixed = false;
                          if ((_hook$dataset = hook.dataset) !== null && _hook$dataset !== void 0 && _hook$dataset.amount) {
                            _this3.overlay.stake = hook.dataset.amount;
                          }
                          if (((_hook$dataset2 = hook.dataset) === null || _hook$dataset2 === void 0 ? void 0 : _hook$dataset2.match) != undefined) {
                            _this3.overlay.one_sided = true;
                            _this3.overlay.player1_stake = hook.dataset.amount;
                            _this3.overlay.player2_stake = hook.dataset.match;
                          }
                          _this3.overlay.render(function (ticker, amount) {
                            var match_amount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                            console.log('SELECTED CRYPTO: ', ticker, amount, match_amount);
                            hook.dataset['ticker'] = ticker;
                            hook.dataset['amount'] = amount;
                            if (match_amount !== null && match_amount !== undefined) {
                              hook.dataset['match'] = match_amount;
                            } else {
                              delete hook.dataset.match;
                            }
                          });
                        case 3:
                          return _context3.a(2);
                      }
                    }, _callee3);
                  }));
                  return function (_x4) {
                    return _ref2.apply(this, arguments);
                  };
                }();
              }
            case 5:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function renderInto(_x3) {
        return _renderInto.apply(this, arguments);
      }
      return renderInto;
    }()
    /**
     * We have a list of each players available cryptos and balances, so
     * we want to calculate an intersection and minimum operation
     */
  }, {
    key: "calculateAvailableCryptos",
    value: function calculateAvailableCryptos(crypto_array) {
      var union = [];
      for (var player in crypto_array) {
        for (var c in crypto_array[player]) {
          if (!union.includes(c)) {
            union.push(c);
          }
        }
      }
      var intersection = {};
      for (var _i = 0, _union = union; _i < _union.length; _i++) {
        var _c = _union[_i];
        var min = 0;
        for (var _player in crypto_array) {
          if (crypto_array[_player][_c]) {
            var value = parseFloat(crypto_array[_player][_c].balance);
            if (min) {
              min = Math.min(min, value);
            } else {
              min = value;
            }
          } else {
            console.log('Not all players have the wallet installed...');
            min = -1;
            break;
          }
        }
        if (min >= 0) {
          intersection[_c] = min;
        }
      }
      return intersection;
    }
  }, {
    key: "includeFeeInMax",
    value: function includeFeeInMax(ticker) {
      var fee = 0;
      var crypto_mod = this.app.wallet.returnCryptoModuleByTicker(ticker);
      crypto_mod.checkWithdrawalFeeForAddress('', function (res) {
        fee = Number(res);
      });
      var diff = Number(this.max_balance) - Number(fee);
      diff = parseFloat(diff.toFixed(8));
      if (diff < 0) {
        this.max_balance = 0;
      } else {
        this.max_balance = diff;
      }
      return fee;
    }
  }, {
    key: "validateBalance",
    value: function () {
      var _validateBalance = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(stake, ticker) {
        var current_balance, network_fee, crypto_mod, needed_balance, _t;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _t = Number;
              _context5.n = 1;
              return this.app.wallet.returnPreferredCryptoBalance();
            case 1:
              current_balance = _t(_context5.v);
              network_fee = 0;
              crypto_mod = this.app.wallet.returnPreferredCrypto();
              _context5.n = 2;
              return crypto_mod.checkWithdrawalFeeForAddress('', function (res) {
                network_fee = Number(res);
              });
            case 2:
              needed_balance = Number(stake) + network_fee;
              if (!(needed_balance > current_balance)) {
                _context5.n = 3;
                break;
              }
              this.app.connection.emit('saito-crypto-deposit-render-request', {
                ticker: ticker,
                amount: needed_balance - current_balance
              });
              return _context5.a(2, false);
            case 3:
              return _context5.a(2, true);
          }
        }, _callee5, this);
      }));
      function validateBalance(_x5, _x6) {
        return _validateBalance.apply(this, arguments);
      }
      return validateBalance;
    }()
  }, {
    key: "returnCryptoOptionsHTML",
    value: function returnCryptoOptionsHTML() {
      var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      values = values || [0.001, 0.01, 0.1, 1, 5, 10, 50, 100, 500, 1000];
      var html = "\n        <div class=\"overlay-input\">\n          <label for=\"crypto\">Crypto:</label>\n          <select class=\"saito-form-select\" id=\"crypto\" name=\"crypto\">\n            <option value=\"\" selected>none</option>";
      var listed = [];
      for (var i = 0; i < this.app.modules.mods.length; i++) {
        if (this.app.modules.mods[i].ticker && !listed.includes(this.app.modules.mods[i].ticker)) {
          html += "<option value=\"".concat(this.app.modules.mods[i].ticker, "\">").concat(this.app.modules.mods[i].ticker, "</option>");
          listed.push(this.app.modules.mods[i].ticker);
        }
      }
      html += "</select></div>";
      html += "<div id=\"stake_input\" class=\"overlay-input\" style=\"display:none;\">\n                <label for=\"stake\">Stake:</label>\n                <select class=\"saito-form-select\" id=\"stake\" name=\"stake\">";
      for (var _i2 = 1; _i2 < values.length; _i2++) {
        html += "<option value=\"".concat(values[_i2], "\" >").concat(values[_i2], "</option>");
      }
      html += "</select></div>";
      return html;
    }
  }]);
}(ModTemplate);
module.exports = Crypto;